"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _FakeDate = _interopRequireDefault(require("./FakeDate"));

var InputDateComponent = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2["default"])(require('./Date'));
  });
});

var InputDate = function InputDate(props) {
  return _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement(_FakeDate["default"], props)
  }, _react["default"].createElement(InputDateComponent, props));
};

var _default = InputDate;
exports["default"] = _default;